import {Route} from '@angular/router';

import {initialDataResolver} from 'app/app.resolvers';

import {AuthGuard} from 'app/core/auth/guards/auth.guard';
import {NoAuthGuard} from 'app/core/auth/guards/noAuth.guard';

import {LayoutComponent} from 'app/layout/layout.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    {path: '', pathMatch : 'full', redirectTo: '/portal/points/redemption-history'},
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: '/portal/points/redemption-history'},

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes')},
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes')},
            {path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes')},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')},
            {path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes')},
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes')},
            {
                path: 'unlock-session',
                loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes')
            }
        ]
    },

    /* Warranty Inquiry (Without Authentication) */
    {
        path: '',
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        data: {
            layout: 'empty'
        },
        children: [
            {
                path: 'lucky-draw',
                loadChildren: () => import('app/modules/lucky-draw/lucky-draw.routes').then(m => m.default)
            },
            {
                path: 'lucky-spin',
                loadChildren: () => import('app/modules/lucky-spin/lucky-spin.routes').then(m => m.default)
            },
            {
                path: 'ETR',
                loadChildren: () => import('app/modules/warranty-inquiry/warranty-inquiry.routes').then(m => m.default)
            },
            {
                path: 'warranty-registration',
                loadChildren: () => import('app/modules/warranty-registration/warranty-registration.routes').then(m => m.default)
            },
            {
              path: 'get-point-form',
                loadChildren: () => import('app/modules/redeem-point/redeem-point.routes').then(m => m.default)
            },
            {
                path: 'product-review',
                loadChildren: () => import('app/modules/product-review/product-review.routes').then(m => m.default)
            },
            {
                path: 'snap-win',
                loadChildren: () => import('app/modules/snap-win/snap-win.routes').then(m => m.default)
            },
            {
                path: ":shortCode",
                loadChildren: () => import('./modules/secure-url/secure-url.route').then(m => m.default)
            },
        ]
    },

    {
        path: 'portal',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            {
                path: '',
                redirectTo:'home',
                pathMatch: 'full'
            },
            {
                path: 'home', loadChildren: () => import('./modules/portal/home/home.route')
            },
            // {
            //     path: 'warranty-list', loadChildren: () => import('app/modules/warranty-list/warranty-list.route').then(m => m.default)
            // },
            {
                path: "my-profile", loadChildren: () => import('app/modules/my-profile/my-profile.routes').then(m => m.default)
            },
            {
                path: "points", loadChildren: () => import('app/modules/point-history/point-history.route').then(m => m.default)
            },
            {
                path: "lucky-spin-list",
                loadChildren: () => import('app/modules/lucky-spin-list/lucky-spin-list.routes').then(m => m.default)
            },
        ]
    },
    {
        path: '**',
        redirectTo: '/portal/points/redemption-history',
        pathMatch: 'full'
    }
];
